export default "__VITE_ASSET__DE$Fo9_F__"